import React from 'react';
import { Link } from 'react-router-dom';
import { Typography,Space } from 'antd';

const Footer = () => {
    return (
        <div className="footer">
                <Typography.Title level={5} style={{color:'white', textAlign:'center'}}>
                    Cryptoverse <br/>
                    All rights reserved By Tashfiq Rahman  
                </Typography.Title>
                <Space>
                    <Link to="/"> Home</Link>
                    <Link to="/exchanges"> Exchanges </Link>
                    <Link to="/news"> News </Link>
                </Space>

         </div>
    )
}

export default Footer;
